import axios from 'axios'

/**
 * axios 实例
 *
 * baseURL 规则：
 *  - 开发环境：使用 /api，由 craco devServer 代理转发到 REACT_APP_API_HOST
 *  - 生产环境：直接使用 REACT_APP_API_HOST 完整地址
 *
 * 两个环境的 REACT_APP_API_HOST 含义一致，都是真实接口域名（只含域名，不含 /api）。
 * 生产构建未配置该变量时回退为同源 `/api`，避免把请求打到错误的域名上。
 */
const apiHost = (process.env.REACT_APP_API_HOST ?? '').trim().replace(/\/+$/, '')
const baseURL = process.env.NODE_ENV === 'development' || !apiHost ? '/api' : `${apiHost}/api`

const instance = axios.create({
  baseURL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
})

export default instance
